import {atom, DefaultValue, selector} from 'recoil';

const preferenceState = atom({
  key: 'preferenceState',
  default: {
    country: false,
    region: false,
    locale: null,
  },
  effects_UNSTABLE: [
    ({setSelf, onSet}) => {
      const savedValue = localStorage.getItem('preference_state');
      if (savedValue != null) {
        try {
          const savedValueDecoded = JSON.parse(savedValue);
          setSelf(savedValueDecoded);
        }
        catch (e) { }
      }

      onSet(newValue => {
        if (newValue instanceof DefaultValue) {
          localStorage.removeItem('preference_state');
        } else {
          localStorage.setItem('preference_state', JSON.stringify(newValue));
        }
      });
    },
  ],
});

export const activeRegionState = selector({
  key: 'activeRegionState',
  get: ({get}) => {
    const preference = get(preferenceState)

    return preference?.region;
  },
  set: ({set}, newValue) => {
    set(preferenceState, old => {
      return {
        ...old,
        region: newValue,
      };
    })
  }
});

export const activeCountryState = selector({
  key: 'activeCountryState',
  get: ({get}) => {
    const preference = get(preferenceState)

    return preference?.country;
  },
  set: ({set}, newValue) => {
    set(preferenceState, old => {
      return {
        ...old,
        country: newValue,
      };
    })
  }
});

export const activeLocaleState = selector({
  key: 'activeLocaleState',
  get: ({get}) => {
    const preference = get(preferenceState)

    return preference?.locale;
  },
  set: ({set}, newValue) => {
    set(preferenceState, old => ({
      ...old,
      locale: newValue,
    }))
  }
});

export default preferenceState;
